import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { ImagesView } from '../../listImages/view/ImagesView';
import { IImageThumbnail } from '../../../Entities';
import { IExtraImageCost } from '../../listImages/queries/use-query-images';
import { IOrderRowQuantitiesInfo } from '../queries/use-query-photo-status';

const ImagesSectionContainer = styled(Box)({
    borderLeft: '1px solid #ddd',
    borderRight: '1px solid #ddd',
    borderBottom: '1px solid #ddd'
}) as typeof Box;

type ImagesBoxProps = {
    user: AuthenticatedUser;
    images: IImageThumbnail[];
    productName: string;
    numberOfImages: number;
    productProperties: any[];
    orderId: number;
    photoStatus: number;
    getEffectiveCategory: (image: IImageThumbnail) => number;
    toggleCategory: (imageId: number) => void;
    deliveredCount: number;
    nonStitchedDeliveredCount: number;
    orderedCount: number;
    orderRowQuantitiesInfo: IOrderRowQuantitiesInfo[];
    extraImageCost: IExtraImageCost | null;
    isApprovalInProgress: boolean;
};

export function ImagesBox({
    user,
    images,
    productName,
    numberOfImages,
    productProperties,
    orderId,
    photoStatus,
    getEffectiveCategory,
    toggleCategory,
    deliveredCount,
    nonStitchedDeliveredCount,
    orderedCount,
    orderRowQuantitiesInfo,
    extraImageCost,
    isApprovalInProgress
}: ImagesBoxProps) {
    return (
        <ImagesSectionContainer component="section">
            <ImagesView
                user={user}
                images={images}
                productName={productName}
                numberOfImages={numberOfImages}
                productProperties={productProperties}
                orderId={orderId}
                photoStatus={photoStatus}
                getEffectiveCategory={getEffectiveCategory}
                toggleCategory={toggleCategory}
                deliveredCount={deliveredCount}
                nonStitchedDeliveredCount={nonStitchedDeliveredCount}
                orderedCount={orderedCount}
                orderRowQuantitiesInfo={orderRowQuantitiesInfo}
                extraImageCost={extraImageCost}
                isApprovalInProgress={isApprovalInProgress}
            />
        </ImagesSectionContainer>
    );
}
